import { apiRequest } from "util/services";

// Thin wrappers around the WhatsApp messaging blueprint (api/messages.py).
// All calls use getFullResult=true so callers can inspect { error } payloads.

export const fetchConversations = () =>
  apiRequest("messages/whatsapp/conversations", "GET", null, true);

export const fetchMessages = (conversationId) =>
  apiRequest(
    `messages/whatsapp/conversations/${conversationId}/messages`,
    "GET",
    null,
    true
  );

export const sendWhatsappMessage = (payload) =>
  apiRequest("messages/whatsapp/send", "POST", payload, true);
